import type { SearchResult } from '@carboncopyco/data';
import type {
  DemoOverlay,
  IDemo,
  IRecording,
  Playbook,
  Tour,
} from '@carboncopyco/types';
import { Grid } from '@carboncopyco/ui';
import {
  CloneSearchResultTile,
  DemoSearchResultTile,
  OverlaySearchResultTile,
  TourSearchResultTile,
} from './tiles';
import { PlaybookSearchResultTile } from './tiles/PlaybookSearchResultTile';

interface AssetGridSectionProps {
  items: SearchResult[];
  archived?: boolean;
  inFolder?: boolean;
}
export const AssetGridSection = ({
  items,
  archived,
  inFolder,
}: AssetGridSectionProps) => {
  return (
    <Grid<SearchResult>
      testDsId="asset-"
      gap="3xl"
      data={items}
      renderItem={(item) => {
        if (item.entityType === 'overlay') {
          return (
            <OverlaySearchResultTile
              demo={item as DemoOverlay}
              archived={archived}
              inFolder={inFolder}
            />
          );
        }
        if (item.entityType === 'demo') {
          return (
            <DemoSearchResultTile
              demo={item as IDemo}
              archived={archived}
              inFolder={inFolder}
            />
          );
        }
        if (item.entityType === 'record') {
          return (
            <CloneSearchResultTile
              clone={item as IRecording}
              archived={archived}
              inFolder={inFolder}
            />
          );
        }
        if (item.entityType === 'tour') {
          return (
            <TourSearchResultTile
              tour={item as Tour}
              archived={archived}
              inFolder={inFolder}
            />
          );
        }
        if (item.entityType === 'playbook') {
          return (
            <PlaybookSearchResultTile
              playbook={item as Playbook}
              archived={archived}
              inFolder={inFolder}
            />
          );
        }
        return;
      }}
    />
  );
};
